import clsx from 'clsx';
import React from 'react';
import {
	DropdownButton,
	OverlayTrigger,
	Tooltip,
	Button,
	Dropdown
} from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';

interface DropdownItem {
	title: string;
	onClickFunc?: () => void;
}

interface IconButtonProps {
	id?: string | number;
	isDropDown?: boolean;
	items?: DropdownItem[];
	drop?: 'up' | 'up-centered' | 'down' | 'down-centered' | 'start' | 'end';
	onClickFunc?: () => void;
	variant?: string;
	size?: 'sm' | 'lg';
	tooltipContent?: string;
	placement?: 'auto-start' | 'auto' | 'auto-end' | 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-end' | 'bottom' | 'bottom-start' | 'left-end' | 'left' | 'left-start';
	children?: React.ReactNode;
	roundedCircle?: boolean;
	className?: string;
}

const IconButton: React.FC<IconButtonProps> = (props) => {
	const {
		id,
		isDropDown,
		items,
		drop,
		onClickFunc,
		variant,
		size,
		tooltipContent,
		placement,
		children,
		roundedCircle,
		className,
	} = props;

	const buttonsSize =
		size && (size === 'sm' || size === 'lg') ? ` icon-btn-${size}` : null;

	const classes = clsx(
		'icon-btn',
		className,
		buttonsSize,
		roundedCircle ? 'rounded-circle' : null,
		'p-2',
	);

	return (
		<OverlayTrigger
			delay={{ show: 250, hide: 400 }}
			overlay={
				<Tooltip className="position-absolute">{tooltipContent}</Tooltip>
			}
			placement={placement}
				trigger={tooltipContent ? ['hover', 'focus'] : []}
		>
			{isDropDown ? (
				<DropdownButton
					className={classes}
					drop={drop}
					id={id ? `icon_button_${id}` : ''}
					size={size}
					title={<BsThreeDotsVertical />}
					variant={variant ? variant : 'secondary'}
				>
					{items?.length &&
						items?.map((item, i) => {
							return (
								<Dropdown.Item
									key={i}
									eventKey={i}
									onClick={item.onClickFunc ? item.onClickFunc : void 0}
								>
									{item.title}
								</Dropdown.Item>
							);
						})}
				</DropdownButton>
			) : (
				<Button
					className={classes}
					size={size}
					variant={variant ? variant : 'secondary'}
					onClick={onClickFunc ? onClickFunc : void 0}
				>
					{children}
				</Button>
			)}
		</OverlayTrigger>
	);
};

export default IconButton;
